export default {
  svg: `
  <svg preserveAspectRatio="xMinYMin" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="5colorWithNotch" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <rect id="PulseVeryLow" x="90" y="20" width="98.903" height="15" />
      <rect id="PulseLow" x="188.903" y="20" width="56.654" height="15" />
      <rect id="PulseNeutral" x="245.557" y="20" width="26.886" height="15" />
      <rect id="PulseHigh" x="272.443" y="20" width="56.654" height="15" />
      <rect id="PulseVeryHigh" x="329.097" y="20" width="98.903" height="15" />

      <g id="PulseBarText">
        <text id="PulseUnstable" text-anchor="left" x="90" y="52" fill="white" font-size="11" font-weight="bold" font-family="Archivo-Regular">Unstable</text>
        <text id="PulseStable" x="390" y="52" fill="white" font-size="11" font-weight="bold" font-family="Archivo-Regular">Stable</text>
      </g>

      <g id="PulseInfo">
        <text id="PulseScore" text-anchor="left" x="5" y="30" fill="white" font-size="35" font-weight="bold" font-family="Archivo-Regular">41</text>
        <text id="PulseDirection" x="50" y="20" fill="white" font-size="15" font-weight="bold" font-family="Archivo-Regular">↑</text>
        <text id="PulseChange" x="63" y="20" fill="white" font-size="15" font-weight="bold" font-family="Archivo-Regular">1</text>
        <text id="PulseAverage" x="5" y="50" fill="white" font-size="13" font-family="Archivo-Light">Avg:</text>
        <text id="PulseAverageRange" x="35" y="50" fill="white" font-size="13" font-family="Archivo-Light">21 - 45</text>
      </g>

      <path id="NotchPath" d="M 90,27 h 338" />

      <g id="Notch">
        <g id="Group-2">
          <ellipse id="Oval" stroke="#D1D1D1" fill="#FFFFFF" cx="12.3223615" cy="12.3333333" rx="11.8223615" ry="11.8333333"></ellipse>
        </g>
        <circle id="Oval" fill="#000000" cx="12" cy="12" r="6"></circle>
      </g>
    </g>
  </svg>
  `,
};
